import React, { ReactNode } from 'react'
import { Paper } from 'shared-components/material/core'

export default function DetailContainer({ children }: { children: ReactNode[] | ReactNode }) {
  return (
    <Paper sx={{ p: 2, height: '100%' }}>{children}</Paper>
  )
}
